var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFairtransportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: 256,
    height: 256,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "       M 128 28       A 100 100 0 1 1 128 228       A 100 100 0 1 1 128 28       Z       M 96 72       H 160 V 96 H 120 V 128 H 160 V 152 H 120 V 200 H 96 Z     "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairtransportIcon);
export default __webpack_public_path__ + "static/media/fairtransport-icon.a6a1f48b2f32af5387a48223cf7ea020.svg";
export { ForwardRef as ReactComponent };